<template>
  <div class="joinUs">
    <div class="banner">
      <div class="banner-center center">
        <div class="banner-info">
          <div class="btn shenqing bgRed" @click="openJoinDialog()">
            立即加盟
          </div>
        </div>
      </div>
    </div>
    <div class="item_1">
      <div class="item-title">
        <h3 class="title2">万亿级市场体量</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <ul>
          <li v-for="(x, index) in item1_list">
            <div class="logo" :class="'item1_bg_' + (index + 1)">
              <p class="title">{{ x.title }}</p>
              <p class="title1">{{ x.title1 }}</p>
            </div>
            <div class="info">{{ x.info }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="item_2">
      <div class="item-title">
        <h3 class="title2">4大加盟优势</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <ul>
          <li v-for="(x, index) in item2_list">
            <div class="logo" :class="'item2_bg_' + (index + 1)"></div>
            <div class="title">{{ x.title }}</div>
            <div class="info">{{ x.info }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="item_3">
      <div class="item-title">
        <h3 class="title2">8大服务支持</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <ul>
          <li v-for="(x, index) in item3_list">
            <div class="title">{{ x.title }}</div>
            <div class="logo">
              <img
                :src="'/static/img/joinus/item3_' + (index + 1) + '.png'"
                alt
              />
            </div>
            <div class="info">{{ x.info }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="item_5">
      <div class="item-title">
        <h3 class="title2">市场认可</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <ul class="top">
          <li class="left">
            <img src="/static/img/aboutUs_intro/zheng_1.png" alt />
            <div class="info">荣获“浙江省高新技术企业”</div>
          </li>
          <li class="right">
            <img src="/static/img/aboutUs_intro/zheng_2.png" alt />
            <div class="info">荣获“浙江省科技型中小企业”</div>
          </li>
        </ul>
        <ul class="bottom">
          <li v-for="(x, index) in item5_list">
            <img
              :src="'/static/img/joinus/item5_' + (index + 1) + '.jpg'"
              style="cursor: pointer;"
              alt
              v-image-preview
            />
          </li>
        </ul>
        <div class="bottom_info">点击查看《计算机软件著作权登记证书》大图</div>
      </div>
    </div>
    <lun-bo></lun-bo>
    <div class="item_4">
      <div class="item-title">
        <h3 class="title2">盈利模式</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <ul>
          <li
            v-for="(x, index) in item4_list"
            :class="'item4_bg_' + (index + 1)"
          >
            <div class="title">{{ x.title }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="item_6">
      <div class="item-title">
        <h3 class="title2">资质要求</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <ul>
          <li
            v-for="(x, index) in item6_list"
            :class="'item6_bg_' + (index + 1)"
          >
            <div class="title">{{ x.title }}</div>
            <img src="/static/img/joinus/duihao.png" alt />
          </li>
        </ul>
      </div>
    </div>
    <div class="item_7">
      <div class="item-title">
        <h3 class="title2">只需4步，开启新征程</h3>
        <div class="marker"></div>
      </div>
      <div class="item-contents center">
        <ul>
          <li
            v-for="(x, index) in item7_list"
            :class="'item7_bg_' + (index + 1)"
          >
            <div class="left">
              <img
                :src="'/static/img/joinus/item7_' + (index + 1) + '.png'"
                alt
              />
              <div class="title">{{ x.title }}</div>
            </div>
            <div class="right" v-show="index != 3">
              <img src="/static/img/joinus/jiantou.png" alt />
            </div>
          </li>
        </ul>
        <div class="btn shenqing bgRed" @click="openJoinDialog()">立即加盟</div>
      </div>
    </div>
    <shen-qing></shen-qing>
  </div>
</template>
<script>
import lunBo from "./lunbo.vue";
import shenQing from "./shenqing.vue";
import joinPop from "./dialog_join.vue";
export default {
  components: {
    lunBo,
    shenQing,
    joinPop
  },
  data() {
    return {
      fromFooter: false,
      map: null,
      marker: null,
      item1_list: [
        {
          title: "< 400万 >",
          title1: "从业人员",
          info:
            "庞大的专业群体，在满足学生多样化学习需求的同时，也推动着行业不断前进"
        },
        {
          title: "< 100万+ >",
          title1: "机构数量",
          info:
            "对优质教育的需求，推动校外培训机构向低线城市和农村地区渗透率逐年递增"
        },
        {
          title: "< 30000亿+ >",
          title1: "市场规模",
          info: "目前，校外培训市场规模已突破30000亿元，市场前景广阔"
        },
        {
          title: "< 30% >",
          title1: "年增速",
          info:
            "校外培训市场规模从2015年的4000亿到目前的30000+亿，年增长率达30%"
        }
      ],
      item2_list: [
        {
          title: "长青行业，前景广阔",
          info: "教育产业百年不衰，校外培训势头迅猛"
        },
        {
          title: "门槛低、收益高",
          info: "成本投入低，收益长久且稳定，投资风险低"
        },
        { title: "起步快，轻运营", info: "只需组建2-3人销售团队，轻量级运营" },
        {
          title: "总部8大扶持",
          info: "总部给予合伙人8大支持，全方位助力开拓市场"
        }
      ],
      item3_list: [
        {
          title: "系统支持",
          info: "系统由总部全程开发、维护、迭代，合伙人只需负责市场开拓"
        },
        {
          title: "市场支持",
          info: "提供易知鸟系统的活动政策、营销推广、代理运营建议"
        },
        { title: "推广支持", info: "为合伙人提供线上+线下营销推广方案" },
        { title: "方案支持", info: "为合伙人提供细分领域行业解决方案" },
        {
          title: "培训支持",
          info: "由合伙人签约的机构，总部将提供1V1产品培训"
        },
        { title: "客服支持", info: "总部提供7*24h客服技术支持" },
        {
          title: "物料支持",
          info: "总部为合伙人提供产品操作手册及营销推广物料"
        },
        { title: "资源支持", info: "总部为合伙人引荐当地优质教育资源" }
      ],
      item5_list: [],
      item4_list: [
        { title: "系统签约分润" },
        { title: "缴费流水分润" },
        { title: "硬件设备差价" },
        { title: "培训服务收益" }
      ],
      item6_list: [
        { title: "具有公司资质，且无不良记录" },
        { title: "认可易知鸟企业文化，对教育行业心怀敬意" },
        { title: "具有3人以上销售团队" }
      ],
      item7_list: [
        { title: "1.提交申请材料" },
        { title: "2.资质审核" },
        { title: "3.洽谈合作方案" },
        { title: "4.签订合作协议" }
      ]
    };
  },
  created() {
    let n = new Array(26);
    this.item5_list = n;
  },
  mounted() {},
  watch: {},
  methods: {
    openDialog: function(title, type) {
      //type:(0机构,1微官网)
      this.$parent.$refs.openPop.openDialog(title, type);
    },
    openJoinDialog: function() {
      this.$parent.$refs.openJoinPop.openJoinDialog();
    }
  }
};
</script>

<style scoped lang="less">
.banner {
  width: 100%;
  height: 700px;
  margin-top: 80px;
  background: url("/static/img/joinus/banner.jpg") no-repeat center;

  .banner-center {
    height: 100%;
    position: relative;
  }

  .banner-info {
    position: absolute;
    bottom: 160px;
    left: 50%;
    margin-left: -90px;
  }
}

.item_1 {
  padding-top: 180px;

  .item-contents {
    padding: 80px 110px 0;

    ul {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        width: 200px;
        height: 340px;

        .logo {
          width: 200px;
          height: 230px;
          padding-top: 77px;

          .title {
            margin: 0 auto 18px;
            color: #fff;
            font-size: 26px;
          }

          .title1 {
            margin: 0 auto;
            color: #fff;
            font-size: 20px;
          }
        }

        .item1_bg_1 {
          background: url("/static/img/joinus/item1_1.png") no-repeat;
          background-size: cover;
        }

        .item1_bg_2 {
          background: url("/static/img/joinus/item1_2.png") no-repeat;
          background-size: cover;
        }

        .item1_bg_3 {
          background: url("/static/img/joinus/item1_3.png") no-repeat;
          background-size: cover;
        }

        .item1_bg_4 {
          background: url("/static/img/joinus/item1_4.png") no-repeat;
          background-size: cover;
        }

        .info {
          margin-top: 40px;
          text-align: left;
          font-size: 16px;
          line-height: 22px;
          color: #999999;
        }
      }
    }
  }
}

.item_2 {
  padding-top: 180px;
  margin-bottom: 200px;

  .item-contents {
    padding: 80px 110px 0;

    ul {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        width: 200px;
        height: 275px;

        .logo {
          width: 120px;
          height: 120px;
          margin-bottom: 70px;
        }

        .item2_bg_1 {
          background: url("/static/img/joinus/item2_1.png") no-repeat;
          background-size: cover;
        }

        .item2_bg_2 {
          background: url("/static/img/joinus/item2_2.png") no-repeat;
          background-size: cover;
        }

        .item2_bg_3 {
          background: url("/static/img/joinus/item2_3.png") no-repeat;
          background-size: cover;
        }

        .item2_bg_4 {
          background: url("/static/img/joinus/item2_4.png") no-repeat;
          background-size: cover;
        }

        .title {
          font-size: 20px;
          font-weight: 500;
          color: #222222;
          margin-bottom: 10px;
          text-align: left;
        }

        .info {
          text-align: left;
          font-size: 16px;
          line-height: 22px;
          color: #999999;
        }
      }
    }
  }
}

.item_3 {
  padding-top: 120px;
  padding-bottom: 120px;
  height: 810px;
  background: url(/static/img/joinus/banner02.jpg) no-repeat center;

  .item-title .title2 {
    color: #fff;
  }

  .item-contents {
    padding: 80px 110px 0;

    ul {
      width: 100%;
      height: 440px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        width: 200px;
        height: 164px;

        .logo {
          width: 60px;
          height: 60px;
          margin: 0 auto 30px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .title {
          font-size: 20px;
          font-weight: 500;
          color: #fff;
          margin-bottom: 10px;
          text-align: center;
        }

        .info {
          text-align: left;
          font-size: 14px;
          line-height: 20px;
          color: #fff;
        }
      }
    }
  }
}

.item_5 {
  padding: 180px 0 100px;

  .item-contents {
    padding-top: 80px;

    ul.top {
      display: flex;
      justify-content: space-between;

      li {
        .info {
          font-size: 20px;
          color: #646464;
          margin-top: 30px;
          text-align: center;
        }
      }

      li.left {
        width: 763px;
      }

      li.right {
        width: 377px;
      }
    }

    ul.bottom {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      // height: 402px;
      margin-top: 100px;
      margin-bottom: 30px;

      li {
        width: 138px;
        height: 195px;
        margin-right: 7px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

.item_4 {
  padding-top: 180px;
  padding-bottom: 180px;

  .item-contents {
    padding-top: 80px;

    ul {
      width: 100%;
      height: 420px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        width: 570px;
        height: 200px;
        padding-top: 80px;

        .title {
          text-align: center;
          color: #fff;
          font-size: 28px;
          line-height: 40px;
        }
      }

      li.item4_bg_1 {
        background: url(/static/img/joinus/item4_1.png) no-repeat center;
        background-size: contain;
      }

      li.item4_bg_2 {
        background: url(/static/img/joinus/item4_2.png) no-repeat center;
        background-size: contain;
      }

      li.item4_bg_3 {
        background: url(/static/img/joinus/item4_3.png) no-repeat center;
        background-size: contain;
      }

      li.item4_bg_4 {
        background: url(/static/img/joinus/item4_4.png) no-repeat center;
        background-size: contain;
      }
    }
  }
}

.item_6 {
  padding-top: 80px;
  padding-bottom: 110px;
  background: url(/static/img/joinus/banner03.jpg) no-repeat center;

  .item-title .title2 {
    color: #fff;
  }

  .item-contents {
    padding-top: 80px;

    ul {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        width: 250px;
        height: 120px;
        padding-top: 70px;
        background: url(/static/img/joinus/item6_li.png) no-repeat center;
        background-size: contain;

        .title {
          display: inline-block;
          max-width: 210px;
          text-align: left;
          color: #fff;
          font-size: 16px;
          line-height: 22px;
        }

        img {
          width: 30px;
          height: 30px;
          display: inline-block;
          vertical-align: top;
        }
      }
    }
  }
}

.item_7 {
  padding-top: 80px;
  padding-bottom: 110px;

  .item-contents {
    padding-top: 80px;

    .shenqing {
      margin: 80px auto 0;
    }

    ul {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        max-width: 260px;
        height: 250px;
        overflow: hidden;
        clear: both;

        .left {
          float: left;

          .title {
            font-size: 20px;
            font-weight: 500;
            color: #222222;
            line-height: 28px;
            margin-top: 57px;
          }

          img {
            width: 164px;
            height: 125px;
          }
        }

        .right {
          float: right;
          width: 40px;
          height: 40px;
          margin-left: 55px;
          margin-top: 42px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/joinUs.vue